import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import LunarReviewsLayout from './layouts/LunarReviewsLayout';

const PendingRunsTab = lazy(() => import('./use-cases/PendingRunsTab'));
const ReviewedRunsTab = lazy(() => import('./use-cases/ReviewedRunsTab'));

const LunarReviewsConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: { display: true },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'lunar-reviews',
      element: <LunarReviewsLayout />,
      children: [
        { path: '', element: <Navigate to="pending" replace /> },
        { path: 'pending', element: <PendingRunsTab /> },
        { path: 'reviewed', element: <ReviewedRunsTab /> },
        { path: '*', element: <Navigate to="pending" replace /> },
      ],
    },
  ],
};

export default LunarReviewsConfig;
